import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="item-card"
// Handles item card interactions: hover effects and navigation
export default class extends Controller {
  static targets = ["hoverOverlay"]
  static values = {
    itemId: String,
    itemPath: String,
  }

  declare readonly hasHoverOverlayTarget: boolean
  declare readonly hoverOverlayTarget: HTMLElement
  declare readonly itemIdValue: string
  declare readonly itemPathValue: string

  private isNavigating = false

  handleMouseEnter() {
    if (this.hasHoverOverlayTarget) {
      this.hoverOverlayTarget.classList.remove("hidden")
      this.hoverOverlayTarget.classList.add("flex")
    }
  }

  handleMouseLeave() {
    if (this.hasHoverOverlayTarget) {
      this.hoverOverlayTarget.classList.add("hidden")
      this.hoverOverlayTarget.classList.remove("flex")
    }
  }

  handleClick() {
    if (this.isNavigating) return
    this.navigate()
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      if (this.isNavigating) return
      this.navigate()
    }
  }

  private navigate() {
    this.isNavigating = true
    // Add visual feedback
    const card = this.element as HTMLElement
    card.classList.add("opacity-75")

    // Turbo visit, NOT window.location: a hard navigation reloads the
    // whole document and kills the global player mid-track — card clicks
    // were the one navigation path that stopped playback.
    window.Turbo.visit(this.itemPathValue)
  }
}
